var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-account",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-account:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-357",
    className: "animable",
    style: {
      transformOrigin: "246.16px 335.844px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-357",
    d: "M85.45 418c88.76 45.38 232.67 45.38 321.42 0s88.76-119 0-164.33-232.66-45.38-321.42 0-88.75 118.96 0 164.33Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "246.16px 335.844px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-357",
    className: "animable",
    style: {
      transformOrigin: "269.102px 343.145px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-357",
    d: "M375.73 345.51c4.87 2.81 14.43 1.84 21.35-2.16L437 320.16c6.93-4 8.59-9.52 3.72-12.34S426.3 306 419.37 310l-39.9 23.21c-6.93 3.97-8.6 9.49-3.74 12.3Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "408.231px 326.666px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-357",
    style: {
      fill: "#ebebeb",
      transformOrigin: "115px 343.45px"
    },
    className: "animable",
    d: "m135.31 366.9-40.62-23.45L135.31 320v46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "217.39px 343.145px"
    },
    className: "animable",
    d: "m250.12 380.93-65.47-37.82 65.48-37.75-.01 75.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-357",
    className: "animable",
    style: {
      transformOrigin: "252.039px 285.776px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-357",
    className: "animable",
    style: {
      transformOrigin: "51.3022px 298.65px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.36 312.07c.12-9.5-6.52-29.27-16.23-41.72S39 248.69 28 252.32c-10.3 3.39-9.35 16.85 3 25.92s30.9 20.49 36.19 36l11.25 19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "50.6516px 292.38px"
    },
    id: "elfgcac0cn7lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36 312.07c.12-9.5-6.52-29.27-16.23-41.72S39 248.69 28 252.32c-10.3 3.39-9.35 16.85 3 25.92s30.9 20.49 36.19 36l11.25 19Z",
    style: {
      opacity: 0.1,
      transformOrigin: "50.6516px 292.38px"
    },
    className: "animable",
    id: "elf5ed2t0e4mh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91 325.08a.69.69 0 0 1-.62-.57c-6-32.51-31.9-59.19-47.53-65.2a.7.7 0 1 1 .5-1.3c15.93 6.13 42.33 33.25 48.39 66.25a.69.69 0 0 1-.55.81Z",
    style: {
      fill: "#fff",
      transformOrigin: "56.9534px 291.507px"
    },
    id: "elmfsj3d293y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.82 345.78c-1.46-5.36-7.88-14.25-18.34-21.66-11.58-8.19-26.3-12.07-29.63-18.38-4-7.58 2.43-14.62 14.4-13S75.1 311 78.18 335.66Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "52.4212px 319.143px"
    },
    id: "elr6hxc8kdu7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.21 340.2a.7.7 0 0 1-.6-.46c-9.61-27.91-30.69-37.92-40.49-39.31a.69.69 0 0 1 .19-1.37c10.84 1.54 31.81 11.74 41.62 40.22a.71.71 0 0 1-.43.89.74.74 0 0 1-.29.03Z",
    style: {
      fill: "#fff",
      transformOrigin: "57.7447px 319.628px"
    },
    id: "elp4qbgepljb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "455.204px 265.772px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.93 285s1.33-20 13.13-34.9 11.08-21 2.94-24-27 14.95-22.84 38.9 6.77 20 6.77 20Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "442.3px 255.508px"
    },
    id: "elzyzw1k65h3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.93 285s1.33-20 13.13-34.9 11.08-21 2.94-24-27 14.95-22.84 38.9 6.77 20 6.77 20Z",
    style: {
      opacity: 0.1,
      transformOrigin: "442.3px 255.508px"
    },
    className: "animable",
    id: "el2zijfczbkzn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32 273.58a.47.47 0 0 1-.47-.43c-1.37-22.06 14.2-40.16 20-44.26a.45.45 0 0 1 .64.11.47.47 0 0 1-.11.65c-5.72 4-21 21.77-19.64 43.44a.47.47 0 0 1-.43.49Z",
    style: {
      fill: "#fff",
      transformOrigin: "441.17px 251.191px"
    },
    id: "el0satcriwmx2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72 301.56a105.38 105.38 0 0 0 16.28 3.92c9.14 1.44 13.18-2.93 13.18-2.93s-3.6-8.57-8.79-11a51.11 51.11 0 0 1 15.86 6.51s5.58.09 7.8-8.43c0 0-3.3-5.13-14.4-7.9 0 0 6.75-1.7 16.48.78.73.29 3.84-10.72 4.78-15.8s-1.1-5-5.06-6.09-17.09-4-19.57-1.83-3.74 9.63-3.74 9.63a17.58 17.58 0 0 1-.37-9.44s-3.56-1.39-9.1.22c-4.52 1.31-4.74 4.39-4.54 7.87a33.87 33.87 0 0 0 2 8.84s-3.53-4.52-3.64-14.33c0 0-9.26 4.6-10.84 13.8-.92 4.99-2.14 19.62 3.67 26.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "455.204px 281.889px"
    },
    id: "elbz6b45jus3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46 299.78a.53.53 0 0 0 .47-.29c7.37-15.33 34.8-33.14 44.62-35.05a.51.51 0 0 0 .41-.6.53.53 0 0 0-.61-.41c-10 1.95-37.86 20-45.35 35.61a.52.52 0 0 0 .24.69.59.59 0 0 0 .22.05Z",
    style: {
      fill: "#fff",
      transformOrigin: "455.96px 281.601px"
    },
    id: "elbpr53c8u47e",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--computer-screen--inject-357",
    className: "animable",
    style: {
      transformOrigin: "177.965px 201.745px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.78 352.86c-1.13 0-1.81-.93-1.81-2.5V182.15L281 63.22v167.53a8.93 8.93 0 0 1-4 7L78.42 352.35a3.33 3.33 0 0 1-1.64.51Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "177.985px 208.04px"
    },
    id: "elnp1nuwkp27d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38 64.23v166.52a8.45 8.45 0 0 1-3.75 6.49l-198.5 114.6a2.77 2.77 0 0 1-1.35.44c-1.11 0-1.23-1.35-1.23-1.92V182.49L280.38 64.23m1.17-2L74.38 181.81v168.55c0 2 1 3.09 2.4 3.09a3.92 3.92 0 0 0 1.93-.59l198.51-114.61a9.58 9.58 0 0 0 4.33-7.5V62.2Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "177.965px 207.825px"
    },
    id: "elo6bwg6mgz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "177.97px 136.08px"
    },
    id: "elpvgnvxb27me",
    className: "animable",
    d: "M74.39 181.81v28.15L281.55 90.35V62.2L74.39 181.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63 183.31v4c0 .82.59 1.16 1.3.75l63.69-36.77v-7l-63.69 36.77a2.91 2.91 0 0 0-1.3 2.25Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "123.125px 166.262px"
    },
    id: "eld5nk7e9u3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45 140.35c.72-.42 1.3-.08 1.3.75v4a2.89 2.89 0 0 1-1.3 2.25l-6.83 3.94v-7Z",
    style: {
      fill: "#455a64",
      transformOrigin: "159.685px 145.73px"
    },
    id: "eldqhibayjghp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.38 172.74a9.58 9.58 0 0 1 4.33-7.5L277.22 50.63c2.39-1.38 4.33-.26 4.33 2.5v9.07L74.38 181.81Z",
    style: {
      fill: "#455a64",
      transformOrigin: "177.965px 115.925px"
    },
    id: "el5o000b2ufql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.52 66.14a4.47 4.47 0 0 0-2 3.51c0 1.3.91 1.82 2 1.18a4.49 4.49 0 0 0 2-3.52c.04-1.31-.87-1.82-2-1.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "258.521px 68.4809px"
    },
    id: "elz1b3tttad6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 62.42a4.47 4.47 0 0 0-2 3.51c0 1.3.91 1.82 2 1.18a4.51 4.51 0 0 0 2-3.52c0-1.3-.92-1.82-2-1.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "265px 64.7618px"
    },
    id: "el6cabhng7iwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39 58.7a4.47 4.47 0 0 0-2 3.51c0 1.3.91 1.82 2 1.18a4.51 4.51 0 0 0 2-3.52c.03-1.3-.88-1.82-2-1.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "271.39px 61.0418px"
    },
    id: "el57yaxa0bjcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "226.715px 107.931px"
    },
    className: "animable",
    id: "el5o4gzn3tl17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.55 108.67a9.82 9.82 0 0 0-4.43 7.7c0 2.83 2 4 4.43 2.56a9.8 9.8 0 0 0 4.44-7.69c.01-2.83-1.99-3.98-4.44-2.57Z",
    id: "el2qzyyrum2pp",
    className: "animable",
    style: {
      transformOrigin: "216.555px 113.808px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.25 120.4a9.8 9.8 0 0 0-4.44 7.69c0 2.83 2 4 4.44 2.57a9.82 9.82 0 0 0 4.43-7.7c0-2.83-1.98-3.96-4.43-2.56Z",
    id: "elxolvvant0mb",
    className: "animable",
    style: {
      transformOrigin: "196.245px 125.536px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86 97a9.8 9.8 0 0 0-4.43 7.69c0 2.83 2 4 4.43 2.56a9.79 9.79 0 0 0 4.44-7.69c0-2.88-1.98-4.03-4.44-2.56Z",
    id: "el2rs2frpyd0f",
    className: "animable",
    style: {
      transformOrigin: "236.865px 102.114px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.18 85.2a9.8 9.8 0 0 0-4.44 7.69c0 2.83 2 4 4.44 2.56a9.8 9.8 0 0 0 4.44-7.69c0-2.83-1.99-3.98-4.44-2.56Z",
    id: "elss3wy41g5p",
    className: "animable",
    style: {
      transformOrigin: "257.18px 90.3294px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m95 212.15 48.21-27.84c2.39-1.38 4.33-.26 4.33 2.5v46.29a9.58 9.58 0 0 1-4.33 7.5L95 268.43c-2.39 1.38-4.33.26-4.33-2.5v-46.28a9.58 9.58 0 0 1 4.33-7.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "119.105px 226.37px"
    },
    id: "elbqpfe3e9ve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 172.28 265 114c2.39-1.39 4.33-.27 4.33 2.5v46.28a9.58 9.58 0 0 1-4.33 7.5l-101 58.28c-2.39 1.38-4.33.26-4.33-2.5v-46.28a9.58 9.58 0 0 1 4.33-7.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "214.5px 171.277px"
    },
    id: "elf9438twow8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95 282.5 76.64-44.25c2.4-1.38 4.34-.4 4.34 2.19a9.29 9.29 0 0 1-4.33 7.19L95 291.88c-2.39 1.38-4.33.4-4.33-2.19A9.29 9.29 0 0 1 95 282.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.325px 265.065px"
    },
    id: "ely7ciusz7eye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95 298.92 76.64-44.25c2.4-1.38 4.34-.4 4.34 2.19a9.29 9.29 0 0 1-4.33 7.19L95 308.3c-2.39 1.38-4.33.4-4.33-2.19a9.29 9.29 0 0 1 4.33-7.19Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.325px 281.485px"
    },
    id: "eltsas2j4b3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95 315.33 76.64-44.25c2.4-1.38 4.34-.4 4.34 2.19a9.29 9.29 0 0 1-4.33 7.19L95 324.71c-2.39 1.38-4.33.4-4.33-2.19a9.29 9.29 0 0 1 4.33-7.19Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.325px 297.895px"
    },
    id: "elaocnwggnmgb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-357",
    className: "animable",
    style: {
      transformOrigin: "204.365px 273.09px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-357",
    className: "animable",
    style: {
      transformOrigin: "204.365px 273.09px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.25 259.67a5.77 5.77 0 0 1 2.6-4.5l132.91-76.73a5.74 5.74 0 0 1 5.2 0l2.93 1.69a5.74 5.74 0 0 1 2.59 4.5v101.88a5.76 5.76 0 0 1-2.59 4.5L142 367.74a5.74 5.74 0 0 1-5.2 0l-2.93-1.69a5.76 5.76 0 0 1-2.6-4.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "204.365px 273.09px"
    },
    id: "elzye0xdawpmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132 257.11 7.38 4.26 137.33-79.3a5.47 5.47 0 0 0-1.83-1.95l-2.88-1.68a5.7 5.7 0 0 0-5.18 0l-132.97 76.73a5.38 5.38 0 0 0-1.85 1.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "204.355px 219.594px"
    },
    className: "animable",
    id: "elqx2dpxf6rde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25 259.67v101.88a5.76 5.76 0 0 0 2.6 4.5l2.93 1.69a3.83 3.83 0 0 0 .71.32 5.78 5.78 0 0 0 1.07.25 6.4 6.4 0 0 0 2.05-.08 3.8 3.8 0 0 0 .51-.13l.31-.12a1.58 1.58 0 0 1-1.25 0 1.8 1.8 0 0 1-.79-1.71v-101.9a2.29 2.29 0 0 1 1.35-2.22l-1.35-.78-7.39-4.26a5.32 5.32 0 0 0-.75 2.56Z",
    style: {
      opacity: 0.1,
      transformOrigin: "136.34px 312.734px"
    },
    className: "animable",
    id: "eli973ztoqjs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.39 261.37 61.55 23a10 10 0 0 0 11.87-3.91l9.88-15.14 54.52-83.53-52.55 84.1 52.82 20.67a5.37 5.37 0 0 1-.81 2.59l-52.15-23L213 284.5a10 10 0 0 1-12.52 3.84l-8.18-3.61L140.18 368a1.8 1.8 0 0 1-.79-1.71v-1.69l52.68-79.93Z",
    style: {
      opacity: 0.2,
      transformOrigin: "208.429px 274.895px"
    },
    className: "animable",
    id: "elh6h4hw6ds57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile-screen--inject-357",
    className: "animable",
    style: {
      transformOrigin: "305.92px 228.525px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.05 144.41v233.9c0 2.76 1.94 3.88 4.33 2.5l105.08-60.67a9.58 9.58 0 0 0 4.33-7.5V78.74c0-2.76-1.94-3.88-4.33-2.5l-105.08 60.67a9.56 9.56 0 0 0-4.33 7.5Z",
    style: {
      fill: "#fafafa",
      stroke: "#e0e0e0",
      strokeMiterlimit: 10,
      strokeWidth: "1.16981px",
      transformOrigin: "305.92px 228.525px"
    },
    id: "elexirf9clfu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14 148.76a2.39 2.39 0 0 1 1.13-1.82l12-6.91c.62-.36 1.12-.12 1.12.53a2.38 2.38 0 0 1-1.12 1.82l-12 6.91c-.62.36-1.13.12-1.13-.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.265px 144.66px"
    },
    id: "elf1wft3lt4s5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14 153.42a2.38 2.38 0 0 1 1.13-1.82l12-6.91c.62-.36 1.12-.12 1.12.52a2.38 2.38 0 0 1-1.12 1.83l-12 6.9c-.62.36-1.13.13-1.13-.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.265px 149.316px"
    },
    id: "elot1gx6fb9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14 158.08a2.38 2.38 0 0 1 1.13-1.82l12-6.91c.62-.36 1.12-.13 1.12.52a2.36 2.36 0 0 1-1.12 1.82l-12 6.91c-.62.4-1.13.13-1.13-.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262.265px 153.984px"
    },
    id: "elmco5v5750mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67 98.1v-1.87a.13.13 0 0 0-.19-.12l-1.44.65a.17.17 0 0 1-.24-.11 3.07 3.07 0 0 0-.32-.71.39.39 0 0 1 0-.35l1-1.94a.21.21 0 0 0-.09-.28l-1-.6a.22.22 0 0 0-.28.07l-1.2 1.8a.37.37 0 0 1-.31.15 3.56 3.56 0 0 0-.78.08.17.17 0 0 1-.22-.15l-.16-1.57c0-.11-.1-.16-.19-.1l-1.62.93a.43.43 0 0 0-.19.3l-.16 1.8a.65.65 0 0 1-.17.34 9 9 0 0 0-.9 1 .3.3 0 0 1-.32.09l-1-.36a.25.25 0 0 0-.29.11l-1.19 2.06a.26.26 0 0 0 .05.3l.84.72a.32.32 0 0 1 .08.32 10.06 10.06 0 0 0-.38 1.26.62.62 0 0 1-.2.31l-1.48 1a.44.44 0 0 0-.17.32v1.86a.12.12 0 0 0 .19.12l1.44-.65a.18.18 0 0 1 .24.12 3.07 3.07 0 0 0 .32.71.39.39 0 0 1 0 .35l-1 1.93a.23.23 0 0 0 .09.29l1 .6a.22.22 0 0 0 .28-.07l1.2-1.8a.37.37 0 0 1 .31-.15 3.56 3.56 0 0 0 .78-.08.17.17 0 0 1 .22.15l.16 1.57c0 .11.09.16.19.1l1.62-.93a.46.46 0 0 0 .19-.31l.16-1.8a.59.59 0 0 1 .17-.33 9 9 0 0 0 .9-1 .3.3 0 0 1 .32-.09l1 .36a.25.25 0 0 0 .29-.11l1.19-2.06a.26.26 0 0 0-.06-.31l-.83-.71a.32.32 0 0 1-.08-.32 10.06 10.06 0 0 0 .38-1.26.54.54 0 0 1 .2-.31l1.48-1a.46.46 0 0 0 .17-.32Zm-6.33 5.9c-1.51.88-2.73.17-2.73-1.57a6 6 0 0 1 2.73-4.74c1.51-.87 2.73-.16 2.73 1.58a6 6 0 0 1-2.73 4.73Z",
    style: {
      fill: "#37474f",
      transformOrigin: "348.409px 100.825px"
    },
    id: "el4z06gtty8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92 144.2c12.28-7.09 22.23-1.34 22.23 12.84s-9.95 31.41-22.23 38.5-22.23 1.34-22.23-12.83 9.95-31.42 22.23-38.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "305.92px 169.87px"
    },
    id: "eljf2k3fv47g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77 155.36c4-2.3 7.21-.44 7.21 4.16a15.94 15.94 0 0 1-7.21 12.48c-4 2.3-7.22.44-7.22-4.16a15.93 15.93 0 0 1 7.22-12.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "305.765px 163.68px"
    },
    id: "elgmwsmaqg8z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 179.88c0-7.55-5.31-10.62-11.85-6.84L304 175.4c-6.54 3.78-11.85 13-11.85 20.53V198a12.43 12.43 0 0 0 3.82.59 20.14 20.14 0 0 0 9.91-3A43.81 43.81 0 0 0 320 181.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "306.075px 185.006px"
    },
    id: "el5v6pgpjvzy6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.86 216.63 326 193.46c1.19-.69 2.16-.2 2.16 1.1a4.65 4.65 0 0 1-2.16 3.59l-40.13 23.17c-1.2.7-2.17.2-2.17-1.09a4.64 4.64 0 0 1 2.16-3.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "305.93px 207.392px"
    },
    id: "eljksv70uax2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55 233.21 330.29 205c1.2-.69 2.17-.2 2.17 1.1a4.64 4.64 0 0 1-2.17 3.59l-48.74 28.21c-1.2.69-2.17.2-2.17-1.1a4.64 4.64 0 0 1 2.17-3.59Z",
    style: {
      fill: "#455a64",
      transformOrigin: "305.92px 221.45px"
    },
    id: "elez2vjmtecw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.59 227.74 13.65-7.88c.72-.41 1.3-.22 1.3.43a2.61 2.61 0 0 1-1.3 1.92l-13.65 7.88c-.71.41-1.3.22-1.3-.42a2.64 2.64 0 0 1 1.3-1.93Z",
    style: {
      fill: "#37474f",
      transformOrigin: "338.415px 224.975px"
    },
    id: "elumqpjx881os",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.4 262.43 20.05-11.57c1.19-.69 2.16-.13 2.16 1.25v13.76a4.8 4.8 0 0 1-2.16 3.75l-20.05 11.57c-1.19.69-2.16.13-2.16-1.25v-13.76a4.8 4.8 0 0 1 2.16-3.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "273.425px 266.025px"
    },
    id: "el2jp0cxekcyz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.6 264.35 13.65-7.88c.72-.41 1.3-.22 1.3.42a2.61 2.61 0 0 1-1.3 1.93l-13.65 7.88c-.72.41-1.3.22-1.3-.42a2.61 2.61 0 0 1 1.3-1.93Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "273.425px 261.585px"
    },
    id: "elnnxiyx1ajss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3 271.29v4c0 .83.58 1.16 1.3.75l13.65-7.88a2.87 2.87 0 0 0 1.3-2.25v-4c0-.83-.58-1.16-1.3-.75L266.6 269a2.89 2.89 0 0 0-1.3 2.29Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "273.425px 268.6px"
    },
    id: "elv9xmorzkeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.9 243.67 20-11.57c1.2-.69 2.17-.13 2.17 1.25v13.76a4.78 4.78 0 0 1-2.17 3.75l-20 11.57c-1.2.69-2.16.13-2.16-1.25v-13.76a4.77 4.77 0 0 1 2.16-3.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "305.905px 247.265px"
    },
    id: "elummvho8wa6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.1 245.59 13.65-7.88c.71-.41 1.29-.22 1.29.42a2.63 2.63 0 0 1-1.29 1.93l-13.65 7.88c-.72.41-1.3.22-1.3-.43a2.61 2.61 0 0 1 1.3-1.92Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "305.92px 242.825px"
    },
    id: "el2eqx7wcgy3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8 252.53v4c0 .83.58 1.16 1.3.75l13.65-7.88a2.89 2.89 0 0 0 1.29-2.25v-4c0-.83-.59-1.16-1.3-.75l-13.65 7.88a2.87 2.87 0 0 0-1.29 2.25Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "305.92px 249.84px"
    },
    id: "elzqdjz4xrkgt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.4 224.91 20-11.58c1.19-.69 2.16-.13 2.16 1.25v13.77a4.8 4.8 0 0 1-2.16 3.75l-20 11.57c-1.2.69-2.17.13-2.17-1.25v-13.76a4.78 4.78 0 0 1 2.17-3.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "338.395px 228.5px"
    },
    id: "el30e18crhh0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.59 226.83 13.65-7.83c.72-.42 1.3-.23 1.3.42a2.58 2.58 0 0 1-1.3 1.92l-13.65 7.88c-.71.42-1.3.23-1.3-.42a2.61 2.61 0 0 1 1.3-1.97Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "338.415px 224.11px"
    },
    id: "elhb95ca1b6n6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.29 233.77v4c0 .82.59 1.16 1.3.75l13.65-7.89a2.86 2.86 0 0 0 1.3-2.25v-4c0-.83-.58-1.17-1.3-.75l-13.65 7.88a2.88 2.88 0 0 0-1.3 2.26Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "338.415px 231.072px"
    },
    id: "ele234ddxmyu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.57 294 80.7-46.59c2.4-1.38 4.33-.4 4.33 2.19a9.26 9.26 0 0 1-4.33 7.19l-80.7 46.59c-2.39 1.38-4.33.4-4.33-2.19a9.29 9.29 0 0 1 4.33-7.19Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "305.92px 275.395px"
    },
    id: "elxu1vn5f96me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.57 312.77 80.7-46.59c2.4-1.38 4.33-.4 4.33 2.19a9.26 9.26 0 0 1-4.33 7.19l-80.7 46.6c-2.39 1.38-4.33.4-4.33-2.2a9.29 9.29 0 0 1 4.33-7.19Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "305.92px 294.17px"
    },
    id: "elcq19a2kw11",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.84 321.06 320 304.8c1.2-.69 2.17-.13 2.17 1.25v9.07a4.78 4.78 0 0 1-2.17 3.75l-28.16 16.26c-1.2.69-2.17.13-2.17-1.25v-9.07a4.78 4.78 0 0 1 2.17-3.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "305.92px 319.965px"
    },
    id: "elzk0nb0jq21l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33 295.39a4.49 4.49 0 0 0-2 3.52c0 1.29.91 1.82 2 1.17a4.49 4.49 0 0 0 2-3.52c.03-1.29-.88-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "267.33px 297.735px"
    },
    id: "el96s73h2hnfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77 291.67a4.47 4.47 0 0 0-2 3.52c0 1.29.9 1.82 2 1.17a4.49 4.49 0 0 0 2-3.52c.03-1.29-.88-1.84-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "273.77px 294.011px"
    },
    id: "el4pxpblyvcmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2 288a4.49 4.49 0 0 0-2 3.52c0 1.29.91 1.82 2 1.17a4.49 4.49 0 0 0 2-3.52c.03-1.34-.88-1.87-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "280.2px 290.329px"
    },
    id: "el54v3o9rs8p3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64 284.23a4.48 4.48 0 0 0-2 3.52c0 1.29.91 1.82 2 1.17a4.49 4.49 0 0 0 2-3.52c.03-1.29-.88-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "286.64px 286.575px"
    },
    id: "eld1leafbfelv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07 280.51a4.49 4.49 0 0 0-2 3.52c0 1.29.91 1.82 2 1.17a4.49 4.49 0 0 0 2-3.52c.03-1.29-.88-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "293.07px 282.855px"
    },
    id: "el88tlix91e7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5 276.79a4.49 4.49 0 0 0-2 3.52c0 1.29.91 1.82 2 1.17a4.47 4.47 0 0 0 2-3.52c.03-1.29-.87-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "299.5px 279.135px"
    },
    id: "eljalb3atcbio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.94 273.07a4.49 4.49 0 0 0-2 3.52c0 1.29.91 1.82 2 1.17a4.49 4.49 0 0 0 2-3.52c.06-1.24-.88-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "305.941px 275.419px"
    },
    id: "eldxgccotbub5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33 314.17a4.51 4.51 0 0 0-2 3.52c0 1.3.91 1.82 2 1.17a4.47 4.47 0 0 0 2-3.51c.03-1.3-.88-1.82-2-1.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "267.33px 316.518px"
    },
    id: "elbxjbm59ntca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77 310.45a4.48 4.48 0 0 0-2 3.52c0 1.3.9 1.82 2 1.17a4.47 4.47 0 0 0 2-3.51c.03-1.3-.88-1.82-2-1.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "273.77px 312.798px"
    },
    id: "el3j1h4w9b0pw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2 306.73a4.51 4.51 0 0 0-2 3.52c0 1.3.91 1.82 2 1.17a4.47 4.47 0 0 0 2-3.51c.03-1.3-.88-1.83-2-1.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "280.2px 309.076px"
    },
    id: "elz3s38ssxv3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64 303a4.49 4.49 0 0 0-2 3.52c0 1.3.91 1.82 2 1.17a4.47 4.47 0 0 0 2-3.51c.03-1.29-.88-1.82-2-1.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "286.64px 305.349px"
    },
    id: "el41ag66nesz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07 299.29a4.49 4.49 0 0 0-2 3.52c0 1.3.91 1.82 2 1.17a4.47 4.47 0 0 0 2-3.51c.03-1.3-.88-1.83-2-1.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "293.07px 301.636px"
    },
    id: "elc3u0erqbu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5 295.57a4.49 4.49 0 0 0-2 3.52c0 1.3.91 1.82 2 1.17a4.45 4.45 0 0 0 2-3.52c.03-1.29-.87-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "299.5px 297.916px"
    },
    id: "elevm6ybpf0xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.94 291.85a4.49 4.49 0 0 0-2 3.52c0 1.3.91 1.82 2 1.17a4.48 4.48 0 0 0 2-3.52c.06-1.29-.88-1.82-2-1.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "305.941px 294.196px"
    },
    id: "eltufsis9t48d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Key--inject-357",
    className: "animable animator-active",
    style: {
      transformOrigin: "406.515px 236.735px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.19 334.13a19.45 19.45 0 0 1-9.85-2.6c-7.21-4.17-11.34-12.87-11.34-23.9 0-19.38 12.32-41.67 28-50.75 8.47-4.89 16.88-5.42 23.69-1.49 7.2 4.16 11.34 12.87 11.34 23.89 0 19.38-12.32 41.68-28.05 50.76a27.9 27.9 0 0 1-13.79 4.09Zm20.66-67.38A14.76 14.76 0 0 0 410 269c-11.4 6.55-21 24.26-21 38.63 0 5.82 1.63 10.24 4.36 11.81 3.11 1.8 7.44-.16 9.73-1.49 11.43-6.59 21.07-24.3 21.07-38.67 0-5.82-1.63-10.23-4.36-11.81a5.68 5.68 0 0 0-2.95-.72Z",
    style: {
      fill: "#455a64",
      transformOrigin: "406.515px 293.457px"
    },
    id: "elgrg7fsitooq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.61 282.38c0-10.89-6.86-14.91-6.86-14.91 2.73 1.58 4.36 6 4.36 11.81 0 14.37-9.64 32.08-21.07 38.67-2.29 1.33-6.61 3.29-9.73 1.49 0 0 5.79 3.6 13.79-.77 11.58-6.31 19.51-21.92 19.51-36.29Z",
    style: {
      fill: "#37474f",
      transformOrigin: "409.96px 294.152px"
    },
    id: "elyjh3hnbqz99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61 146.29a7.22 7.22 0 0 0-14.43 0V261a3.61 3.61 0 0 0 2.11 3 11.31 11.31 0 0 0 10.2 0 3.6 3.6 0 0 0 2.12-3V146.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "408.395px 202.277px"
    },
    id: "eloh5c8fs60qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85 171.93a9.22 9.22 0 0 0-4.17-7.22 2.9 2.9 0 0 0-3-.26L384.9 174.7l-.43.25a.67.67 0 0 0-.18.11 6.25 6.25 0 0 0-.85.69 5.9 5.9 0 0 0 6.95 9.38l.34-.2 17.91-10.31a2.93 2.93 0 0 0 1.21-2.69Z",
    style: {
      fill: "#455a64",
      transformOrigin: "395.786px 174.989px"
    },
    id: "ellcjyz7d17n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85 200.65a9.22 9.22 0 0 0-4.17-7.21 2.88 2.88 0 0 0-3-.27l-20.86 12-.43.25a.78.78 0 0 0-.18.11 5.69 5.69 0 0 0-.85.69 5.92 5.92 0 0 0 1.32 9.38 6 6 0 0 0 2.82.7 5.88 5.88 0 0 0 2.81-.7c.12-.06.23-.14.34-.2l21-12a2.93 2.93 0 0 0 1.2-2.75Z",
    style: {
      fill: "#455a64",
      transformOrigin: "394.245px 204.585px"
    },
    id: "elmch926px25b",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/noAccess.a5052912c444adc0544ee5836b2e63d2.svg";
export { ForwardRef as ReactComponent };